<template>
    <div :class="delType === 'topic'
            ? 'f-icon-topic-delete' : 'f-icon-reply-delete'"
        @click="del">
        <img class="f-icon-delete-img" :src="icon">
        <span class="f-icon-delete-word">删除</span>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/icon/delete-icon.less';
</style>

<script>
export default {
    props: {
        delType: {
            'type': String,
            'default': 'topic'
        }
    },
    data() {
        return {
            topicDelIcon: require('@/assets/images/icon-topic/delete.png'),
            replyDelIcon: require('@/assets/images/icon-reply/delete.png')
        };
    },
    computed: {
        icon: {
            get() {
                return this.delType === 'topic'
                    ? this.topicDelIcon : this.replyDelIcon;
            }
        }
    },
    methods: {
        del() {
            if (this.delType === 'topic') {
                this.$emit('topicDel');
            }
            else {
                this.$emit('replyDel');
            }
        }
    }
};
</script>
